module.exports = __webpack_public_path__ + "static/media/contest2025_second_place_profileImage.ce0d85ed.jpeg";